// Ausgewählte Projekte / Arbeitsproben
// Inhalte basieren auf den Arbeitsproben (Simply V, LinkedIn, Kaufland) und
// weiteren Kollaborationen bei DEPARTD.
export const CASES = [
  {
    id: "case-01",
    number: "01",
    title: "Always-On Content — Kaufland",
    brand: "Kaufland — via DEPARTD",
    role: "Junior TikTok Creative",
    period: "2024 — 2025",
    description:
      "Kontinuierliche Ideenentwicklung und Trend-Research für den Kaufland-TikTok-Account (ca. 10 neue Content-Ideen pro Woche). Mitentwicklung von „Der kleine Gerrit\" und laufenden Content-Formaten.",
    results: [
      "1 Mio.+ Views auf ein einzelnes Video",
      "10 Mio.+ Views auf YouTube Shorts",
      "TOP 3 meistgesehenes Video des Kanals",
    ],
    tags: ["Always-On", "TikTok", "Trend Research"],
    link: null,
    cover: "",
  },
  {
    id: "case-02",
    number: "02",
    title: "TikTok Launch — LinkedIn Praktikumschallenge",
    brand: "LinkedIn — via DEPARTD",
    role: "Creative & Strategy",
    period: "2024 — 2025",
    description:
      "Mitwirkung an der TikTok-Expansion von LinkedIn: Format „Praktikumschallenge\" mit dem Dreiklang Berufsorientierung, Entertainment und LinkedIn Education — im nativen TikTok-Storytelling.",
    results: [
      "Konzept & Story-Framework",
      "Trend-Integration im nativen Format",
      "Zielgruppe: Gen Z",
    ],
    tags: ["TikTok", "Brand Launch", "Storytelling"],
    link: null,
    cover: "",
  },
  {
    id: "case-03",
    number: "03",
    title: "Trend-Konzept — Simply V (TTCX)",
    brand: "Simply V — via DEPARTD",
    role: "Junior TikTok Creative",
    period: "2024 — 2025",
    description:
      "Kreativ-Konzept für die natürliche Integration eines aktuellen TikTok-Trends in die Produktkommunikation. Leitgedanke: Trend zuerst, Produkt organisch einweben.",
    results: [
      "Trend-Discovery & Konzept",
      "Creative Concepting",
      "Team-Umsetzung",
    ],
    tags: ["TikTok", "Trend Integration", "Creative Concepting"],
    link: null,
    cover: "",
  },
  {
    id: "case-04",
    number: "04",
    title: "TikTok Ads — Groß- und Kleinkunden",
    brand: "u. a. Vodafone, Durex, Domino's — via DEPARTD",
    role: "Junior TikTok Creative",
    period: "2024 — 2025",
    description:
      "Kreativ-Konzeption und Skripting zahlreicher TikTok-Ads für Groß- und Kleinkunden — vom Hook bis zum Call-to-Action.",
    results: [
      "Kampagnen-Konzepte",
      "Hook-Frameworks",
      "Ad-Skripte & Copy",
    ],
    tags: ["TikTok Ads", "Performance Creative", "Copywriting"],
    link: null,
    cover: "",
  },
];
